const DB_NAME = "barpadi-offline";
let dbp = null;

function open() {
  if (dbp) return dbp;
  dbp = new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      const d = req.result;
      if (!d.objectStoreNames.contains("kv")) d.createObjectStore("kv");
      if (!d.objectStoreNames.contains("outbox")) d.createObjectStore("outbox", { keyPath: "event_id" });
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
  return dbp;
}

function run(store, mode, op) {
  return open().then(
    (d) =>
      new Promise((resolve, reject) => {
        const t = d.transaction(store, mode);
        const req = op(t.objectStore(store));
        t.oncomplete = () => resolve(req ? req.result : undefined);
        t.onerror = () => reject(t.error);
      })
  );
}

export const dbGet = (key) => run("kv", "readonly", (s) => s.get(key));
export const dbSet = (key, value) => run("kv", "readwrite", (s) => s.put(value, key));
export const outboxAdd = (ev) => run("outbox", "readwrite", (s) => s.put(ev));
export const outboxPut = (ev) => run("outbox", "readwrite", (s) => s.put(ev));
export const outboxAll = () => run("outbox", "readonly", (s) => s.getAll());
export const outboxDelete = (eventId) => run("outbox", "readwrite", (s) => s.delete(eventId));
